'use strict';

exports.__esModule = true;
exports['default'] = lifecycle;

var _validators = require('../../utils/validators');

function lifecycle(values) {
  return function (target) {
    (0, _validators.validateClass)(target, 'lifecycle');

    Object.keys(values).forEach(function (name) {
      Object.defineProperty(target.prototype, name, {
        value: values[name]
      });
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/lifecycle.js
// module id = 584
// module chunks = 1